module.exports = __webpack_public_path__ + "static/flags/DE-ef48841ae623e223ff1e5f9bd03f080a.gif";